import { useEffect } from 'react';
import { ProductItem } from './product-item/product-item.component';
import { BusinessStore } from '../../../store/businessStore';
import { style } from './products.module.css';

import {
  Text,
  Table,
  TableHeader 
} from '@recargas-dominicanas/core/components';

interface Props {
  businessId: number;
}

export function Products(props: Props) {

  const { businessId } = props;

  const products = BusinessStore.getProducts(businessId);

  useEffect(() => {
    BusinessStore.fetchProducts(businessId);
  }, []);

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <Text text='Logo'/>
          <Text text='Nombre'/>
          <Text text='Tipo'/>
          <Text text='Beneficio'/>
          <span></span>
        </TableHeader>
        <tbody>
          {
            products?.map(product => (
              <ProductItem
                key={product.id}
                businessProduct={product}/>
            ))
          }
        </tbody>
      </Table>
    </div>
  );
}
